import { isArray, isNil, isPlainObject } from 'lodash'

// Guided-setup drafts: the wizard's raw working state, saved per user in localStorage so a
// half-built scorecard survives closing the modal (v1 — per-browser; a server-side store can
// replace this layer without touching the wizard). Storage is a trust boundary: the blob can be
// stale, hand-edited, or written by another tab, so loading normalizes shapes and every access is
// try/caught — storage being unavailable (private mode, quota) must degrade to "no draft", never
// break the wizard.
const DRAFT_VERSION = 1

const draftKey = (userId) => `qaCopilotGuidedDraft:${userId}`

export const loadGuidedDraft = (userId) => {
  if (isNil(userId)) {
    return null
  }

  try {
    const raw = localStorage.getItem(draftKey(userId))
    const draft = raw ? JSON.parse(raw) : null

    if (draft?.version !== DRAFT_VERSION) {
      return null
    }

    return {
      ...draft,
      eligibility: isPlainObject(draft.eligibility) ? draft.eligibility : {},
      sections: isArray(draft.sections) ? draft.sections : [],
      criteriaRows: isArray(draft.criteriaRows) ? draft.criteriaRows : [],
    }
  } catch (error) {
    return null
  }
}

export const saveGuidedDraft = (userId, draft) => {
  if (isNil(userId)) {
    return false
  }

  try {
    localStorage.setItem(draftKey(userId), JSON.stringify({ ...draft, version: DRAFT_VERSION }))
    return true
  } catch (error) {
    return false
  }
}

export const clearGuidedDraft = (userId) => {
  if (isNil(userId)) {
    return
  }

  try {
    localStorage.removeItem(draftKey(userId))
  } catch (error) {
    // ignore — see saveGuidedDraft
  }
}
